const energyGuide = {
  id: "energy-guide-1",
  title: "Energy Guide",
  category: "Guides",
  override: "tools/energy/other",
  meta: {
    description: "A comprehensive guide of Pixels Energy",
    keywords: ["energy", "beginner", "wine", "game", "sauna"],
    author: "Pixelore",
    date: "2026-02-08",
  },
  sections: [
    {
      type: "subdivision",
      id: "how-to-gain-energy",
      title: "How to Gain Energy",
      content: [
        {
          type: "text",
          data: `These are available ways to earn energy within the game aside from items:<br />
          ⚡Regular Energy Regen: 0.8E/min [21 Hours for 1000 Energy]
           <br />
           ⚡Sauna Energy: 120 extra Energy for an hour per day [Stay online in the sauna pool for 1 hour to receive the recharge]
            <br />
            ⚡VIP Energy: 1000E every 8 hours for Tier 1 VIP, 6 hours for Tier 2 VIP, 4 hours for Tier 3 and 4 VIP [Just click the sauna rocks for an instant recharge]
            <br />⚡House Beds: 300 Energy - resets at 12 AM UTC`,
        },
        {
          type: "text",
          data: `🏠 You can only use one bed per 24h even if you own multiple lands
          <br /> 🏠 The Sauna can be used once every 24 hours. [23 hours from the end of your regen, 24 Hours from the start].<br/>
          🔛 You must stay online while you use the Sauna<br/>
          ➡️ If you do not use all the energy, you can continue to recharge by going back to the Sauna. <br/>
          ➡️ If you go back on a new day, you'll regain the amount remaining, plus the amount for the new day.`,
        },
      ],
    },
    {
      type: "subdivision",
      id: "energy-loss",
      title: "Energy Loss",
      content: [
        {
          type: "text",
          data: `These are ways you lose energy in the game aside from leveling skills:<br />
            ⛓️‍💥 0.5 Energy for switching maps [unless you have a pet]
            <br />
            ⛓️‍💥 0.5 Energy for each purchase from the marketplace<br />
            ⛓️‍💥 Varying energy for using the UI Infinifunnel`,
        },
      ],
    },
    {
      id: "pixels-energy-other",
      title: "Other Info",
      type: "subdivision",
      content: [
        {
          type: "text",
          data: "⛓️Majority of food & energy items are not tradable. Wines are tradable.",
        },
      ],
    },
  ],
};

export default energyGuide;
